<div class="cookie-banner" *ngIf="showBanner">
  <div class="cookie-text">
    {{ 'COOKIE_BANNER.MESSAGE' | translate }}
    <a routerLink="/cookie-policy">{{ 'COOKIE_BANNER.MORE_INFO' | translate }}</a>
  </div>
  <div class="cookie-buttons">
    <button class="accept" (click)="acceptCookies()">{{ 'COOKIE_BANNER.ACCEPT' | translate }}</button>
    <button class="decline" (click)="declineCookies()">{{ 'COOKIE_BANNER.DECLINE' | translate }}</button>
  </div>
</div>
